import { FC, useMemo } from 'react';

import clsx from 'clsx';

import { renderIcon } from 'shared/components/ui/HistoryIcon/renderIconByMove';
import { RoundWinnerOutcomes, bgColor } from 'shared/constants/shared-enums';
import { useRoomStore } from 'shared/store/roomStore';

interface Props {
  round: {
    moveA: number;
    moveB: number;
    winner: RoundWinnerOutcomes;
  };
  gameCount: number;
}

const HistoryMove: FC<Props> = ({ round, gameCount }) => {
  const { amIPlayerA } = useRoomStore();
  const playerAClass = amIPlayerA ? 'order-1' : 'order-3';
  const playerBClass = amIPlayerA ? 'order-3' : 'order-1';
  const playerAMoveIcon = useMemo(
    () => renderIcon(round.moveA, playerAClass === 'order-1'),
    [round, playerAClass],
  );

  const playerBMoveIcon = useMemo(
    () => renderIcon(round.moveB, playerBClass === 'order-1'),
    [round, playerBClass],
  );
  let bgColorClass = bgColor.default;
  if (round.winner === RoundWinnerOutcomes.None) return null;
  if (round.winner === RoundWinnerOutcomes.PlayerA && amIPlayerA) bgColorClass = bgColor.win;
  if (round.winner === RoundWinnerOutcomes.PlayerB && !amIPlayerA) bgColorClass = bgColor.win;
  if (round.winner === RoundWinnerOutcomes.PlayerA && !amIPlayerA) bgColorClass = bgColor.lose;
  if (round.winner === RoundWinnerOutcomes.PlayerB && amIPlayerA) bgColorClass = bgColor.lose;

  return (
    <div className="flex w-full flex-col items-center">
      <div
        className={clsx('mb-2 flex w-[95%] items-center justify-between rounded', {
          'bg-violet': bgColorClass === bgColor.default,
          'bg-history-content-win': bgColorClass === bgColor.win,
          'bg-history-content-lose': bgColorClass === bgColor.lose,
        })}
      >
        <div className={`flex w-[33%] justify-center ${playerAClass}`}>{playerAMoveIcon}</div>
        <span className="order-2 flex w-[33%] justify-center text-[30px] font-medium text-white">
          {gameCount}
        </span>
        <div className={`flex w-[33%] justify-center ${playerBClass}`}>{playerBMoveIcon}</div>
      </div>
    </div>
  );
};

export default HistoryMove;
